import React from "react";

export default function PublicReadingProgressBar({ progress = 0 }) {
  return (
    <div className="fixed left-0 right-0 top-0 z-50 h-1 bg-background/60" aria-hidden="true">
      <div
        className="h-full bg-gradient-to-r from-primary via-accent to-secondary transition-[width] duration-150 ease-out"
        style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
      />
    </div>
  );
}